export default __webpack_public_path__ + "static/media/flag-fr.216f9179.svg";